import React from 'react';
import { CheckmarkIcon } from './Icons';
export const ProductIntroduction = () => {
  const features = ['The myth of conventional medication — why pills silence symptoms but never fix the root cause', 'The 3 Pillars of the Hormonal Reset — Estrogen Detox, Metabolic Sync and Cortisol Management', 'The Raw Carrot Protocol — the $0.50 tool functional doctors use to eliminate excess estrogen', 'Your detailed 30-Day Plan — week by week, day by day, with simple and concrete actions', 'The 4 mistakes sabotaging your recovery — and how to eliminate them from Day 1', 'The functional lab guide — what to request at your next appointment and how to interpret it'];
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-148">
      <div className="max-w-[780px] mx-auto text-center" data-id="element-149">
        <div className="font-lato font-bold text-[13px] text-medium tracking-[0.2em] mb-4" data-id="element-150">
          INTRODUCING
        </div>

        <h1 className="font-playfair text-[32px] md:text-[52px] text-primary mb-6" data-id="element-151">
          The Hormonal Balance Code
        </h1>

        <p className="font-lato text-[16px] md:text-[20px] text-secondary max-w-[680px] mx-auto mb-12" data-id="element-152">
          The natural 30-day method to reset your metabolism, calm your symptoms
          and feel like yourself again — without medication or expensive
          protocols
        </p>

        <div className="max-w-[680px] mx-auto text-left grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-153">
          {features.map((feature, index) => <div key={index} className="group flex items-start gap-4 bg-light hover:bg-accent/40 transition-colors duration-300 rounded-[12px] p-5 border border-accent/60" data-id="element-154">
              <div className="flex-shrink-0 inline-flex items-center justify-center rounded-full" style={{
            width: '32px',
            height: '32px',
            background: '#957DAD',
            boxShadow: '0 4px 12px rgba(149,125,173,0.35)'
          }} aria-hidden="true" data-id="element-155">
                <CheckmarkIcon color="#FFFFFF" size={18} data-id="element-156" />
              </div>
              <p className="font-lato text-[15px] md:text-[16px] text-body leading-[1.6] m-0 flex-1" data-id="element-157">
                {feature}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};